import { createContext, useContext, Context, PropsWithChildren, useMemo, useState, useEffect } from 'react'
import { View } from 'react-native'

import RootStore, { Config } from './store'

const StoreContext = createContext<RootStore | undefined>(undefined)

interface Props {
  config: Config
  onLoaded?: () => void
}

export const useStore = (): RootStore => {
  return useContext(StoreContext as Context<RootStore>)
}

const StoreProvider = (props: PropsWithChildren<Props>) => {
  const { children, config, onLoaded } = props
  const store = useMemo(() => config.test_store || new RootStore(config), [])
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    const init = async () => {
      await store.init(config)
      setLoaded(true)
      onLoaded?.()
    }
    init()
  }, [store])

  if (!loaded) return <View />
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

export default StoreProvider
